export const advancedSettingsMessages = {
  "advancedSettings.title": "Advanced Settings",
  "advancedSettings.environmentVariables.title": "Environment Variables",
  "advancedSettings.environmentVariables.subtitle": "Applied before each prompt or session command",
  "advancedSettings.actions.close": "Close",
} as const
